"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiAccordionSummary = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var general_1 = require("../../generated/icons/general");
var global_1 = require("../../global");
var createMuiAccordionSummary = function (theme) {
    var _a;
    return ({
        defaultProps: {
            expandIcon: (0, jsx_runtime_1.jsx)(general_1.SimpleArrowDown, { width: "16", height: "16" }, void 0),
        },
        styleOverrides: {
            root: {
                fontWeight: global_1.fontWeight.bold,
            },
            content: {
                margin: 0,
            },
            expandIconWrapper: (_a = {},
                _a[theme.breakpoints.up("sm")] = {
                    "& svg": {
                        width: "24px",
                        height: "24px",
                    },
                },
                _a),
        },
    });
};
exports.createMuiAccordionSummary = createMuiAccordionSummary;
//# sourceMappingURL=accordion-summary.js.map